import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=bf288f2a&"
import script from "./QuizPage.vue?vue&type=script&lang=js&"
export * from "./QuizPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports